export default function useObjectValidation() {
  const isEmpty = (object: object) => {
    return Object.keys(object).length === 0;
  };

  return {
    isEmpty,
  };
}
